import React,{useState} from 'react'
import {Box} from '@mui/material'
import Exercises from '../componenets/Exercises'
import HeroBanner from '../componenets/HeroBanner'
import SearchExercises from '../componenets/SearchExercises'
const Home = () => {
  const [bodyPart, setbodyPart] = useState('all')
  const [exercises, setExercises] = useState([])
  return (
    <Box>
        <HeroBanner/>
        <SearchExercises setExercises={setExercises} bodyPart = {bodyPart} setBodyPart = {setbodyPart}/>
        <Exercises exercises = {exercises} setExercises={setExercises} bodyPart = {bodyPart} />
    </Box>
  )
}

export default Home